import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import SideBar from '../commun/SideBar';
import Hearder from '../commun/Hearder';
import html2pdf from 'html2pdf.js';
import axios from 'axios';
import ReactDOMServer from 'react-dom/server';
import { getBankdetal, PropertyBookingCancle, Propertybookingpdf, Propertybookings, PropertyCancelReason, PropertyDynamicVoucher, PropertyVoucherSend } from '../../Services/Service';

import swal from "sweetalert";



const BookingList = () => {
  // const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [showSuccess, setShowSuccess] = useState(false);
  const [bookingData, setBookingData] = useState([]);

  const [cancelCodes, setCancelCodes] = useState([]);
  const [selectedCode, setSelectedCode] = useState("");
  const [cancelReason, setCancelReason] = useState("");
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [bankFormData, setBankFormData] = useState(null);
  const [emails, setEmails] = useState([]);
  const [inputEmail, setInputEmail] = useState("");
  const [error, setError] = useState("");
  const [filters, setFilters] = useState({
    BookingDate: "",
    GuestName: "",
    CheckInDate: "",
    CheckOutDate: "",
  });


  useEffect(() => {
    const fetchBookings = async () => {
      setLoading(true);
      try {
        const data = await Propertybookings("", "", "", "", "");
        // setBookingData(data || []);
        setBookingData((data || []).reverse());
      } catch (error) {
        console.log("Error fetching bookings", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBookings();
  }, [])


  const handleFilter = async () => {
    setLoading(true);
    try {
      // destroy old datatable
      if (window.$.fn.DataTable.isDataTable(".basic-datatables")) {
        window.$(".basic-datatables").DataTable().destroy();
      }

      const data = await Propertybookings(
        filters.BookingDate,
        filters.GuestName,
        filters.CheckInDate,
        filters.CheckOutDate
      );

      setBookingData((data || []).reverse());
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };


  const handleClear = async () => {
    setFilters({
      BookingDate: "",
      GuestName: "",
      CheckInDate: "",
      CheckOutDate: "",
    });

    if (window.$.fn.DataTable.isDataTable(".basic-datatables")) {
      window.$(".basic-datatables").DataTable().destroy();
    }

    const data = await Propertybookings("", "", "", "");
    setBookingData((data || []).reverse());
  };



  useEffect(() => {
    if (location.state?.showSuccess) {
      setShowSuccess(true);

      const timer = setTimeout(() => {
        setShowSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [location.state]);

  useEffect(() => {
    const getBankdetails = async () => {
      setLoading(true);
      try {
        const result = await getBankdetal();
        if (result && result.length > 0) {
          setBankFormData(result[0]);
        }
      }
      catch (error) {
        console.log("error get bank details", error);
      } finally {
        setLoading(false);
      }
    }
    getBankdetails();
  }, []);

  // small helper to safely get string values
  // const safe = (val) => (val === null || val === undefined ? "" : String(val));

  // const random = Math.floor(Math.random() * 1000) + 1;


  // const handleGenerateVoucher = async (item) => {
  //   setLoading(true);

  //   try {
  //     // 1️⃣ Get voucher data
  //     const voucherData = await Propertybookingpdf(item.BONRESID);
  //     if (!voucherData) {
  //       alert("Unable to fetch voucher details");
  //       return;
  //     }

  //     const guest = voucherData.Table?.[0] || {};
  //     const room = voucherData.Table1?.[0] || {};
  //     const hotel = voucherData.Table3?.[0] || {};
  //     const BookingID = voucherData.Table4?.[0] || {};

  //     const bookingCommentObj = guest.BookingComment
  //       ? JSON.parse(guest.BookingComment)[0]
  //       : {};
  //     const bookingComment = bookingCommentObj?.BookingComment || "";

  //     const adultsCount = Number(room.adults ?? room.Adults ?? 0) || 0;
  //     const childrenCount = Number(room.Child ?? room.Children ?? 0) || 0;
  //     const guestsToShow = adultsCount + childrenCount;

  //     let paymentComment = "";
  //     try {
  //       const paymentCommentArr = guest.PaymentComment
  //         ? JSON.parse(guest.PaymentComment)
  //         : null;
  //       paymentComment =
  //         Array.isArray(paymentCommentArr) && paymentCommentArr.length
  //           ? paymentCommentArr[0].PaymentComment || ""
  //           : "";
  //     } catch {
  //       paymentComment = "";
  //     }

  //     const totalRoom =
  //       guest.TotalRoom ??
  //       BookingID.TotalRoom ??
  //       room.TotalRoom ??
  //       0;

  //     const propertyId = Number(localStorage.getItem("PropertyID"));
  //     const random = Math.floor(Math.random() * 1000) + 1;

  //     let filePath = "";
  //     if (propertyId === 27)
  //       filePath = `/Voucher Templates/Uday_Palace_27.html?v=${random}`;
  //     else if (propertyId === 25)
  //       filePath = `/Voucher Templates/25/Voucher.html?v=${random}`;
  //     else if (propertyId === 26)
  //       filePath = `/Voucher Templates/26/Voucher.html?v=${random}`;
  //     else if (propertyId === 29)
  //       filePath = `/Voucher Templates/Bhairavgarh_Palace_29.html?v=${random}`;
  //     else if (propertyId === 30)
  //       filePath = `/Voucher Templates/The_Chinar_Resort_30.html?v=${random}`;
  //     else if (propertyId === 31)
  //       filePath = `/Voucher Templates/Ramada_Indor_31.html?v=${random}`;
  //     else if (propertyId === 32)
  //       filePath = `/Voucher Templates/32/Voucher.html?v=${random}`;
  //     else if (propertyId === 28)
  //       filePath = `/Voucher Templates/Jasraj_Palace_Tavatmal_28.html?v=${random}`;
  //     else {
  //       alert("Voucher template not found for this property");
  //       return;
  //     }

  //     // 2️⃣ Fetch Template
  //     const response = await fetch(filePath);
  //     if (!response.ok) {
  //       alert("Failed to load voucher template");
  //       return;
  //     }

  //     let templateHTML = await response.text();
  //     const bank = bankFormData || {};

  //     const safe = (val) => (val === undefined || val === null ? "" : val);

  //     // 3️⃣ Replace placeholders
  //     templateHTML = templateHTML
  //       .replace(/{{Title}}/g, safe(guest.Title))
  //       .replace(/{{FirstName}}/g, safe(guest.FirstName))
  //       .replace(/{{LastName}}/g, safe(guest.LastName))
  //       .replace(/{{BookingDate}}/g, safe(guest.BookingDate))
  //       .replace(/{{RoomName}}/g, safe(room.RoomName))
  //       .replace(/{{MealPlan}}/g, safe(room.MeelPlan))
  //       .replace(/{{CheckInDate}}/g, safe(room.CheckInDate))
  //       .replace(/{{CheckOutDate}}/g, safe(room.CheckOutDate))
  //       .replace(/{{Nights}}/g, safe(room.Nights))
  //       .replace(/{{Guests}}/g, guestsToShow)
  //       .replace(/{{TotalRoom}}/g, totalRoom)
  //       .replace(/{{RoomRate}}/g, safe(room.RoomRate))
  //       .replace(/{{ExtraBedAmount}}/g, safe(room.ExtraBedAmount))
  //       .replace(/{{TotalAfterTax}}/g, safe(BookingID.TotalAfterTax))
  //       .replace(/{{BONRESID}}/g, safe(BookingID.BONRESID))
  //       .replace(/{{PropertyLogo}}/g, safe(hotel.PropertyLogo))
  //       .replace(/{{DisplayName}}/g, safe(hotel.DisplayName))
  //       .replace(/{{Address}}/g, safe(hotel.Address))
  //       .replace(/{{HotelPhone}}/g, safe(hotel.HotelPhone))
  //       .replace(/{{HotelEmail}}/g, safe(hotel.HotelEmail))
  //       .replace(/{{BookingComment}}/g, safe(bookingComment))
  //       .replace(/{{PaymentComment}}/g, safe(paymentComment))
  //       .replace(/{{BranchName}}/g, safe(bank.BranchName))
  //       .replace(/{{AccountHoldername}}/g, safe(bank.AccountHoldername))
  //       .replace(/{{Accountno}}/g, safe(bank.Accountno))
  //       .replace(/{{IFSCCode}}/g, safe(bank.IFSCCode));

  //     // 4️⃣ PDF Options
  //     let opt = {
  //       margin: 0,
  //       filename: `BookingVoucher_${item.BONRESID}.pdf`,
  //       image: { type: "jpeg", quality: 0.98 },
  //       html2canvas: { scale: 2 },
  //       jsPDF: { unit: "in", format: "a4", orientation: "portrait" }
  //     };

  //     // 5️⃣ Generate PDF Blob
  //     let pdfBlob = await html2pdf()
  //       .set(opt)
  //       .from(templateHTML)
  //       .outputPdf("blob");

  //     // 6️⃣ Check Size
  //     let sizeBytes = pdfBlob.size;
  //     let sizeKB = (sizeBytes / 1024).toFixed(2);
  //     let sizeMB = (sizeBytes / (1024 * 1024)).toFixed(2);

  //     console.log("📄 PDF Size:");
  //     console.log("Bytes:", sizeBytes);
  //     console.log("KB:", sizeKB + " KB");
  //     console.log("MB:", sizeMB + " MB");

  //     // 7️⃣ Auto compress if > 1MB
  //     if (sizeBytes > 1024 * 1024) {
  //       console.log("⚠ PDF > 1MB. Compressing...");

  //       opt = {
  //         ...opt,
  //         image: { type: "jpeg", quality: 0.7 },
  //         html2canvas: { scale: 1.5 }
  //       };

  //       pdfBlob = await html2pdf()
  //         .set(opt)
  //         .from(templateHTML)
  //         .outputPdf("blob");

  //       sizeBytes = pdfBlob.size;
  //       sizeKB = (sizeBytes / 1024).toFixed(2);
  //       sizeMB = (sizeBytes / (1024 * 1024)).toFixed(2);

  //       console.log("✅ Compressed Size:", sizeMB + " MB");
  //     }

  //     // 8️⃣ Download
  //     const url = URL.createObjectURL(pdfBlob);
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = `BookingVoucher_${item.BONRESID}.pdf`;
  //     document.body.appendChild(a);
  //     a.click();
  //     document.body.removeChild(a);
  //     URL.revokeObjectURL(url);

  //   } catch (error) {
  //     console.error("Error generating voucher PDF:", error);
  //     alert("Error generating PDF");
  //   } finally {
  //     setLoading(false);
  //   }
  // };



  // const handleGenerateVoucher = async (bonResId) => {
  //   try {
  //     setLoading(true);

  //     // Call API
  //     const data = await PropertyDynamicVoucher(bonResId);
  //     const url = data?.url;

  //     if (!url) {
  //       alert("Voucher URL not found");
  //       return;
  //     }

  //     // console.log("url", url)
  //     // Download via Blob
  //     const response = await axios.get(url, {
  //       responseType: "blob",
  //     });

  //     const blob = new Blob([response.data], { type: "application/pdf" });

  //     // ✅ Size in Bytes
  //     const sizeInBytes = blob.size;

  //     // ✅ Convert to KB
  //     const sizeInKB = (sizeInBytes / 1024).toFixed(2);

  //     // ✅ Convert to MB
  //     const sizeInMB = (sizeInBytes / (1024 * 1024)).toFixed(2);

  //     console.log(`PDF Size:
  //   Bytes: ${sizeInBytes} B
  //   KB: ${sizeInKB} KB
  //   MB: ${sizeInMB} MB
  //   `);

  //     const blobUrl = window.URL.createObjectURL(blob);

  //     const a = document.createElement("a");
  //     a.href = blobUrl;
  //     a.download = `Voucher_${bonResId}.pdf`;
  //     document.body.appendChild(a);
  //     a.click();
  //     a.remove();

  //     window.URL.revokeObjectURL(blobUrl);

  //   } catch (error) {
  //     console.error("Voucher download failed:", error);
  //     alert("Failed to download voucher");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleGenerateVoucher = async (bonResId) => {
    try {
      setLoading(true);

      const data = await PropertyDynamicVoucher(bonResId);
      const url = data?.url;

      if (!url) {
        alert("Voucher URL not found");
        return;
      }

      // ✅ Open the voucher in a new tab
      window.open(url, "_blank");

    } catch (error) {
      console.error("Voucher open failed:", error);
      alert("Failed to open voucher");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (bookingData.length > 0 && window.$) {
      setTimeout(() => {
        window.$(".basic-datatables").DataTable({
          destroy: true,
        });
      }, 0);
    }
  }, [bookingData]);


  // Booking Cancel reason Function
  useEffect(() => {
    const fetchCancelReason = async () => {
      try {
        const result = await PropertyCancelReason();
        console.log("reason data", result);
        setCancelCodes(result || []);
      }
      catch (error) {
        console.log("error fetching cancel resons in Booking list page", error);
      }
    }
    fetchCancelReason();
  }, []);

  const handleCodeChange = (e) => {
    const code = e.target.value;
    setSelectedCode(code);

    const selected = cancelCodes.find((c) => c.Code === code);
    if (selected) {
      setCancelReason(selected.Description);
    } else {
      setCancelReason("");
    }
  };

  // reset form
  const resetCancelForm = () => {
    setSelectedCode("");
    setCancelReason("");
    setSelectedBooking(null);
  };

  // booking cancle
  const handleCancelBooking = async (item) => {

    if (!selectedCode) {
      alert("Please select a cancellation code.");
      return;
    }

    if (!cancelReason) {
      alert("Please enter a reason.");
      return;
    }

    setLoading(true);
    try {
      const result = await PropertyBookingCancle(item.BONRESID, item.PropertyID, selectedCode, cancelReason);

      if (result && result.BONRESID) {
        swal("Booking cancelled successfully!", {
          icon: "success",
          buttons: {
            confirm: {
              text: "OK",
              className: "btn btn-success",
            },
          },
        }).then(() => {

          const modal = window.bootstrap.Modal.getInstance(
            document.getElementById("Cancel-Booking-Resion")
          );
          if (modal) modal.hide();

          resetCancelForm(); // reset fields
        });

        // Table update: remove cancelled booking ya fetch list again
        setBookingData((prev) =>
          prev.map((b) =>
            b.BONRESID === item.BONRESID ? { ...b, BookingStatus: "Cancelled" } : b
          )
        );

      } else {
        alert(result?.message || "Failed to cancel booking");
      }
    } catch (error) {
      console.error(error);
      alert("Error cancelling booking");
    } finally {
      setLoading(false);
    }

  };


  const isValidEmail = (value) => {
    const email = value.trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const addEmail = (value) => {
    if (!value) return false;

    const parts = value
      .split(/[\s,;]+/)
      .map(p => p.trim())
      .filter(Boolean);

    let addedAny = false;

    for (let p of parts) {
      if (!isValidEmail(p)) {
        setError(`Invalid email: ${p}`);
        return false;
      }
      if (!emails.includes(p)) {
        setEmails(prev => [...prev, p]);
        addedAny = true;
      }
    }

    setInputEmail("");
    setError("");
    return addedAny;
  };

  const removeEmail = (emailToRemove) => {
    setEmails(prev => prev.filter(e => e !== emailToRemove));
  };

  const editEmail = (emailToEdit) => {
    setInputEmail(emailToEdit);
    setEmails(prev => prev.filter(e => e !== emailToEdit));
  };

  const handlePaste = (e) => {
    const paste = e.clipboardData.getData("text");
    if (paste && /[,;\s]/.test(paste)) {
      e.preventDefault();
      addEmail(paste);
    }
  };


  const handleSendVoucher = async () => {
    if (!selectedBooking) {
      alert("No booking selected!");
      return;
    }

    // Single email auto add
    if (inputEmail) {
      const added = addEmail(inputEmail);
      if (!added) return;
    }

    if (emails.length === 0) {
      alert("Please enter at least one email!");
      return;
    }

    const id = selectedBooking.BONRESID;
    const EmailID = emails.join(",");

    try {
      setLoading(true);
      const response = await PropertyVoucherSend(id, EmailID);

      if (response?.url) {
        alert("Voucher sent successfully!");

        const modalEl = document.getElementById("zoomInModal");
        const modal =
          window.bootstrap.Modal.getInstance(modalEl) ||
          new window.bootstrap.Modal(modalEl);
        modal.hide();

        setEmails([]);
        setInputEmail("");
      } else {
        alert("Failed to send voucher!");
      }
    } catch (err) {
      console.error(err);
      alert("Failed to send voucher!");
    } finally {
      setLoading(false);
    }
  };




  return (
    <>
      <style>{`
         
        tr th{
           font-size: 12px !important;
        }
           label{
             font-weight:bold !important;
           }

           .booking-filter-form .card-body .d-flex > div {
            flex: 0 0 auto;
            max-width: none;
          }

      @media (max-width: 768px) {
        .booking-filter-form .card-body .d-flex {
          flex-wrap: wrap;
          gap: 0.75rem;
          align-items: flex-start;
        }

  .booking-filter-form .card-body .d-flex > div {
    flex: 0 0 100%;
    max-width: 100%;
    width: 100%;
  }

  .booking-filter-form .card-body .d-flex > div .btn {
    min-width: 110px;    
  }

  @media (max-width: 420px) {
    .booking-filter-form .card-body .d-flex > div:last-child {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
    .booking-filter-form .card-body .d-flex > div:last-child .btn {
      width: 100%;
      min-width: unset;
    }
  }

  .booking-filter-form .card-body .form-label {
    font-size: 0.92rem;
  }
}

.booking-filter-form .card-body .form-control {
  box-sizing: border-box;
  width: 100%;
}

.badge {    
    margin-left: initial;
      }

      
    `}</style>

      {loading && (
        <div className="fullscreen-loader">
          <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
        </div>
      )}

      <div className="wrapper ">
        <SideBar />
        <div className="main-panel">
          <Hearder />

          <div className="container">
            <div className="page-inner">
              <div className="row">
                <div className="col-md-12">

                  {/* <div className='card'>
                    <div className='card-body'>

                      <form>
                        <div className='row'>
                          <div className='col-md-2'>
                            <label className='form-label fw-bold'>Booking Date</label>
                            <input className='form-control' type='date'
                              value={filters.BookingDate}
                              onChange={(e) => setFilters({ ...filters, BookingDate: e.target.value })}
                            />
                          </div>

                          <div className='col-md-3'>
                            <label className='form-label fw-bold'>Guest Name</label>
                            <input className='form-control' type='text'
                              placeholder='Enter Name'
                              value={filters.GuestName}
                              onChange={(e) => setFilters({ ...filters, GuestName: e.target.value })}
                            />
                          </div>

                          <div className='col-md-3'>
                            <label className='form-label fw-bold'>Company Name</label>
                            <input className='form-control' type='text' placeholder='Enter Company'
                              value={filters.CompName}
                              onChange={(e) => setFilters({ ...filters, CompName: e.target.value })}
                            />
                          </div>

                          <div className='col-md-2'>
                            <label className='form-label fw-bold'>Check-In</label>
                            <input className='form-control' type='date'
                              value={filters.CheckInDate}
                              onChange={(e) => setFilters({ ...filters, CheckInDate: e.target.value })}
                            />
                          </div>

                          <div className='col-md-2'>
                            <label className='form-label fw-bold'>Check-Out</label>
                            <input className='form-control' type='date'
                              value={filters.CheckOutDate}
                              onChange={(e) => setFilters({ ...filters, CheckOutDate: e.target.value })}
                            />
                          </div>
                        </div>

                        <div className='text-end mt-3'>
                          <button className='btn btn-primary me-2' type='button' onClick={handleFilter}>
                            Filter
                          </button>
                          <button className='btn btn-info' type='button' onClick={handleClear}>
                            Clear
                          </button>
                        </div>
                      </form>
                    </div>
                  </div> */}

                  <div className='card booking-filter-form'>
                    <div className='card-body'>

                      <form>
                        <div className='d-flex gap-3'>
                          <div>
                            <label className='form-label'>Booking Date</label>
                            <input
                              className='form-control'
                              type='date'
                              value={filters.BookingDate}
                              onChange={(e) =>
                                setFilters({ ...filters, BookingDate: e.target.value })
                              }
                            />
                          </div>

                          <div>
                            <label className='form-label'>Guest Name</label>
                            <input
                              className='form-control'
                              type='text'
                              placeholder='Enter Guest name'
                              value={filters.GuestName}
                              onChange={(e) =>
                                setFilters({ ...filters, GuestName: e.target.value })
                              }
                            />
                          </div>

                          <div>
                            <label className='form-label'>Company name</label>
                            <input className='form-control' type='text' placeholder='Enter Company name' />
                          </div>

                          <div>
                            <label className='form-label'>Check-In</label>
                            <input
                              className='form-control'
                              type='date'
                              value={filters.CheckInDate}
                              onChange={(e) =>
                                setFilters({ ...filters, CheckInDate: e.target.value })
                              }
                            />
                          </div>

                          <div>
                            <label className='form-label'>Check-Out</label>
                            <input
                              className='form-control'
                              type='date'
                              value={filters.CheckOutDate}
                              onChange={(e) =>
                                setFilters({ ...filters, CheckOutDate: e.target.value })
                              }
                            />
                          </div>

                          <div className='text-end' style={{ marginTop: "27px" }}>
                            <button
                              className='btn btn-primary me-2'
                              type='button'
                              onClick={handleFilter}
                            >
                              Filter
                            </button>

                            <button
                              className='btn btn-danger'
                              type='button'
                              onClick={handleClear}
                            >
                              Clear
                            </button>
                          </div>
                        </div>
                      </form>

                    </div>
                  </div>


                  {showSuccess && (
                    <div className="alert alert-success d-flex align-items-center" role="alert">
                      <i className="feather-check-circle flex-shrink-0 me-2"></i>
                      <div>Your booking details submitted to Hotel!</div>
                    </div>
                  )}


                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Booking List</h4>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table
                          // id="basic-datatables"
                          className="display table  table-bordered table-striped table-hover basic-datatables"
                        // style={{ width: '100%', tableLayout: 'auto' }}
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "45px" }}>Sr#</th>
                              <th style={{ width: "110px" }} >BON REF. Id</th>
                              <th style={{ width: "110px" }}>Conf. No</th>
                              <th style={{ width: "95px" }}>Check-in</th>
                              <th style={{ width: "110px" }}>Check-out</th>
                              <th >Guest Info</th>

                              <th>Moboile no</th>
                              <th style={{ width: "81px" }}>Payment </th>
                              <th style={{ width: "81px" }}>Status</th>
                              <th style={{ width: "95px" }}>Book On</th>
                              <th>Action </th>
                            </tr>
                          </thead>

                          <tbody>
                            {bookingData.map((item) => (
                              <tr key={item.ID}>
                                <td>{item.SrNo}</td>
                                <td>{item.BONRESID}</td>
                                <td>{item.PMSRESID}</td>
                                <td>{item.CheckInDate}</td>
                                <td> {item.CheckOutDate}</td>
                                <td>
                                  <b>{item.GuestName}</b>
                                  <div>{item.CompanyName}</div>
                                  <div>Email: {(() => {
                                    try {
                                      const gd = JSON.parse(item.GuestDetails);
                                      return gd?.[0]?.EMailAddress || "N/A";
                                    } catch {
                                      return "N/A";
                                    }
                                  })()}</div>
                                </td>
                                <td>
                                  {(() => {
                                    try {
                                      const gd = JSON.parse(item.GuestDetails);
                                      return gd?.[0]?.MobileNumber || "N/A";
                                    } catch {
                                      return "N/A";
                                    }
                                  })()}
                                </td>

                                <td>
                                  <div> <span > ₹ {item.TotalPayment} </span></div>
                                  <div>
                                    <span
                                      className={
                                        item.PaymentStatus === "Paid"
                                          ? "text-success"
                                          : item.PaymentStatus === "Pending"
                                            ? "text-warning"
                                            : "text-secondary"
                                      }
                                    >
                                      {item.PaymentStatus || "N/A"}
                                    </span>
                                  </div>
                                </td>

                                <td className="text-center">
                                  <span
                                    className={
                                      item.BookingStatus === "Confirmed"
                                        ? "text-success"
                                        : item.BookingStatus === "Pending"
                                          ? "text-warning"
                                          : item.BookingStatus === "Cancelled"
                                            ? "text-danger"
                                            : "text-secondary"
                                    }
                                  >
                                    {item.BookingStatus || "N/A"}
                                  </span>
                                </td>
                                <td>{item.BookingDate}</td>
                                <td className="text-center">
                                  <div className="dropdown dropdown-action">
                                    <a href="" className="action-icon" data-bs-toggle="dropdown" aria-expanded="false" >
                                      <i className="fas fa-ellipsis-v" style={{ color: "#333" }}></i>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-right" >
                                      {/* <button type='button' className="dropdown-item" onClick={() => handleModifyClick(item)}><i className='fas fa-edit me-1'></i> Modify </button> */}
                                      {/* <a href='/Property/EditBooking' className="dropdown-item" ><i className='fas fa-edit me-1'></i> Modify </a> */}
                                      {item.BookingStatus !== "Cancelled" && item.BookingStatus !== "Pending" && (

                                        <button type="button" className="dropdown-item" data-bs-toggle="modal"
                                          data-bs-target="#Cancel-Booking-Resion" onClick={() => {
                                            setSelectedBooking(item); setSelectedCode(""); // reset code
                                            setCancelReason("");
                                          }} ><i className='fas fa-ban me-2'></i>Cancelled</button>
                                      )}

                                      {/* <button className="dropdown-item" onClick={() => handleGenerateVoucher(item)} > <i className="fas fa-sticky-note me-2"></i> Booking Voucher </button> */}
                                      <button className="dropdown-item" onClick={() => handleGenerateVoucher(item.BONRESID)}> <i className="fas fa-sticky-note me-2"></i> Booking Voucher </button>
                                      <button type="button" class="dropdown-item" data-bs-toggle="modal" data-bs-target="#zoomInModal" onClick={() => setSelectedBooking(item)}><i className='fas fa-envelope me-2'></i>Send Voucher</button>
                                      <NavLink to={`/Property/VoucherDetail/${item.BONRESID}`} className="dropdown-item " style={{ color: "#333", padding: "2px 14px", background: "none" }}><i className="fa fa-info-circle me-2"></i>Voucher Details</NavLink>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal fade"
            id="Cancel-Booking-Resion"
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title" id="exampleModalLabel">
                    Booking Cancel
                  </h4>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">

                  <div className="mb-3">
                    <label className="col-form-label">Code:</label>
                    <select className="form-control form-select" value={selectedCode}
                      onChange={handleCodeChange}>
                      <option>Select Code</option>
                      {cancelCodes.map((c) => (
                        <option key={c.Code} value={c.Code}>
                          {c.Code}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="" className="col-form-label">
                      Cancel Reason:
                    </label>
                    <textarea className="form-control" value={cancelReason}
                      onChange={(e) => setCancelReason(e.target.value)} />
                  </div>

                </div>
                <div className="modal-footer">
                  <button type="button" onClick={() => handleCancelBooking(selectedBooking)} className="btn btn-danger">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>

          <>
            {/* Modal Blur */}
            <div
              id="zoomInModal"
              className="modal fade zoomIn"
              tabIndex={-1}
              aria-labelledby="zoomInModalLabel"
              aria-hidden="true"
              style={{ display: "none" }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="zoomInModalLabel">
                      Send Voucher
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    />
                  </div>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-12">
                        {/* inside your modal-body */}
                        <div className="email-input-wrapper form-control d-flex  gap-2" style={{ minHeight: "42px" }}>
                          {emails.map((email, index) => (
                            <span
                              key={index}
                              className="badge bg-primary align-items-center"
                              style={{ cursor: "pointer" }}
                              onClick={() => editEmail(email)}
                              title="Click to edit"
                            >
                              {email}
                              <button
                                className="btn-close btn-close-white ms-2"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  removeEmail(email);
                                }}
                              />
                            </span>
                          ))}

                          <input
                            type="text"
                            value={inputEmail}
                            onChange={(e) => { setInputEmail(e.target.value); if (error) setError(""); }}

                            onPaste={handlePaste}
                            placeholder={emails.length === 0 ? "Enter Email Address" : ""}
                            className="border-0 "
                            style={{ outline: "none", minWidth: "200px" }}
                          />
                        </div>
                      </div>
                    </div>

                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-warning"
                      onClick={() => inputEmail && addEmail(inputEmail)}
                    >
                      Add More
                    </button>

                    <button type="button" className="btn btn-primary" onClick={handleSendVoucher}>
                      Send
                    </button>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>
            {/* /.modal */}
          </>


        </div>

      </div>

    </>
  );
};

export default BookingList;
